import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { FilterTickIcon, TableFilterIcon } from './svgIcon';
import Button from './Button';
import { getI18Next } from '../../utils/helpers';

function TableFilter(props) {
  const [style, setStyle] = useState({ right: '0px' });
  const currentLanguageCode = getI18Next();
  const modalRef = useRef(null);
  const { t } = useTranslation();
  const handleFilterClick = (filterName) => {
    props?.setSelectedFilter((prevState) => (prevState === filterName ? null : filterName));
  };

  const handleClick = (event) => {
    event.stopPropagation(); // Prevent event bubbling
    // setOpen((prevOpen) => !prevOpen); // Toggle state
    if (!props?.isColumnOpen && !props?.isShrunk && !props?.isViewOpen && !props?.isTagOpen) {
      props?.setIsFilterOpen(!props?.isFilterOpen);
    } else {
      if (props?.isColumnOpen) {
        props?.setIsColumnOpen(!props?.isColumnOpen);
        props?.setIsFilterOpen(!props?.isFilterOpen);
      }
      if (props?.isShrunk) {
        props?.setIsShrunk(!props?.isShrunk);
        props?.setIsFilterOpen(!props?.isFilterOpen);
      }
      if (props?.isTagOpen) {
        props?.setIsTagOpen(!props?.isTagOpen);
        props?.setIsFilterOpen(!props?.isFilterOpen);
      }
      if (props?.isViewOpen) {
        props?.setIsViewOpen(!props?.isViewOpen);
        props?.setIsFilterOpen(!props?.isFilterOpen);
      }
    }
    if (window.innerWidth / 2 > event.clientX) {
      if (currentLanguageCode === 'ar') {
        setStyle({ left: '0px', top: '40px' });
      } else {
        setStyle({ left: '45px', top: '0px' });
      }
    } else {
      setStyle({ right: '0px' });
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        props?.setIsFilterOpen(false); // Close modal if clicked outside
      }
    };

    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);
  return (
    <div
      className={`Table-filter-wrap ${props?.isFilterOpen && 'active'}`}
      onClick={handleClick}
      role="presentation"
    >
      {props?.tagCount > 0 && <div className="tag">{props?.tagCount}</div>}
      <TableFilterIcon />
      {props?.title && <p className="common-filter">{props?.title}</p>}
      {props?.isFilterOpen && (
        <div
          className="column-modal"
          onClick={(e) => e.stopPropagation()}
          style={style}
          role="none"
          ref={modalRef}
        >
          <div
            className={`first-pane ${currentLanguageCode === 'ar' ? 'rtl' : ''}`}
            onClick={(e) => e.stopPropagation()}
            role="none"
          >
            <span>{t('viewBy')}</span>
            <div className="content-wrap">
              <FilterTickIcon />
              <p>{props?.viewByName ? props?.viewByName : t('myContent')}</p>
            </div>
          </div>
          <div
            className={`second-pane ${currentLanguageCode === 'ar' ? 'rtl' : ''}`}
            onClick={(e) => e.stopPropagation()}
            role="none"
          >
            <span>{t('filterBy')}</span>
            <div className="filters-list">
              {props?.filterData?.map((filter) => (
                <div
                  key={filter?.name}
                  className={`filter-item ${props?.selectedFilter === filter?.name ? 'selected' : ''}`}
                  onClick={() => handleFilterClick(filter?.name)} // Toggle selection
                  role="presentation"
                >
                  {props?.selectedFilter === filter?.name && <FilterTickIcon />} {/* Show tick icon if selected */}
                  <p>{filter?.name}</p>
                </div>
              ))}
            </div>
          </div>
          <div
            className={`third-pane ${currentLanguageCode === 'ar' ? 'rtl' : ''}`}
            onClick={(e) => e.stopPropagation()}
            role="none"
          >
            <span>{t('results')}</span>
            <div className="results-content">
              {/* Conditionally render the component based on the selected filter */}
              {props?.selectedFilter === null ? (
                <p>{t('noFilterSelected')}</p> // Display message if no filter is selected
              ) : (
                // Find the corresponding filter component from the Filter array
                props?.filterData?.map((filter) => {
                  if (filter?.name === props?.selectedFilter) {
                    return (
                      <div key={filter?.name} className="filter-component">
                        {filter?.component}
                      </div>
                    );
                  }
                  return null;
                })
              )}
            </div>
          </div>
          <div className="column-header">
            <div />
            <Button
              label={t('apply')}
              click={() => props?.applyFilter(props?.filterTag)}
              classes="success-button"
              disabled={props?.disabled}
            />
          </div>
        </div>
      )}
    </div>
  );
}

TableFilter.propTypes = {
  title: PropTypes.string.isRequired,
  tagCount: PropTypes.string.isRequired,
  selectedFilter: PropTypes.string.isRequired,
  viewByName: PropTypes.string.isRequired,
  setSelectedFilter: PropTypes.func.isRequired,
  filterData: PropTypes.arrayOf.isRequired,
  filterTag: PropTypes.arrayOf.isRequired,
  isColumnOpen: PropTypes.bool.isRequired,
  setIsColumnOpen: PropTypes.func.isRequired,
  isFilterOpen: PropTypes.bool.isRequired,
  setIsFilterOpen: PropTypes.func.isRequired,
  applyFilter: PropTypes.func.isRequired,
  setIsShrunk: PropTypes.func.isRequired,
  isShrunk: PropTypes.bool.isRequired,
  isTagOpen: PropTypes.bool.isRequired,
  setIsTagOpen: PropTypes.func.isRequired,
  disabled: PropTypes.func.isRequired,
  isViewOpen: PropTypes.bool.isRequired,
  setIsViewOpen: PropTypes.func.isRequired,
};

export default TableFilter;
